import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "strengthBar", "strengthText"]

  checkStrength() {
    const password = this.passwordTarget.value
    const strength = this.calculateStrength(password)
    
    this.updateStrengthDisplay(strength)
  }

  calculateStrength(password) {
    let strength = 0
    
    // Length check
    if (password.length >= 8) strength += 20
    if (password.length >= 12) strength += 10
    if (password.length >= 16) strength += 10

    // Character type checks
    if (/[a-z]/.test(password)) strength += 15  // lowercase
    if (/[A-Z]/.test(password)) strength += 15  // uppercase
    if (/[0-9]/.test(password)) strength += 15  // numbers
    if (/[^A-Za-z0-9]/.test(password)) strength += 15  // special characters

    return Math.min(strength, 100)
  }

  updateStrengthDisplay(strength) {
    // Update progress bar
    this.strengthBarTarget.style.width = `${strength}%`
    
    // Update color and text based on strength
    let color, text
    
    if (strength === 0) {
      color = "bg-gray-300"
      text = "-"
    } else if (strength < 40) {
      color = "bg-red-500"
      text = "弱い"
    } else if (strength < 60) {
      color = "bg-yellow-500"
      text = "普通"
    } else if (strength < 80) {
      color = "bg-blue-500"
      text = "強い"
    } else {
      color = "bg-green-500"
      text = "非常に強い"
    }

    // Remove all color classes and add the new one
    this.strengthBarTarget.className = `h-2 rounded-full transition-all duration-300 ${color}`
    this.strengthTextTarget.textContent = text
    
    // Update text color to match bar
    this.strengthTextTarget.className = `text-xs ${color.replace('bg-', 'text-')}`
  }
}
